import * as XLSX from "xlsx";
import { getUmfangFromCategories } from "@/pages/kundenverwaltung/ParsingMixin";
import { extractFromDateString } from "@/helper/dateService";
import { formatLeistungsart } from "@/helper/leistungsart";
import {PRODUKTE_VALUES} from "@/components/kundenverwaltung/valueLists";


const VERTRAGSTYP_VALUES = [
  { text: 'Privat', value: '0' },
  { text: 'Gewerbe', value: 'G' },
  { text: 'Landwirtschaft', value: 'L' },
  { text: 'Medizin', value: 'K' },
  { text: 'Vereine', value: 'V' },
  { text: 'None', value: 'N' }
];

// getting the offset once should be enough
const timeZoneOffset = new Date().getTimezoneOffset();

export default {
  methods: {
    generateExcel: function (table, columnFormat, fileName) {
      const wb = XLSX.utils.book_new();
      const sheet = XLSX.utils.json_to_sheet(table);
      sheet["!cols"] = columnFormat;
      this.formatColumnForExcel(sheet, columnFormat);
      sheet['!autofilter'] = { ref: sheet['!ref'] };
      XLSX.utils.book_append_sheet(wb, sheet, 'Tabelle1');
      XLSX.writeFile(wb, fileName + ".xlsx");
    },
    formatColumnForExcel(sheet, columnFormat) {
      Object.keys(sheet).forEach(key => {
        if (key.charAt(0) >= 'A' && key.charAt(0) <= 'Z') {
          let columnNumber = key.charCodeAt(0) - 'A'.charCodeAt(0);
          if (columnFormat[columnNumber].z !== undefined) {
            sheet[key].z = columnFormat[columnNumber].z;
          }
        }
      });
    },
    formatBestandDataForExcel: function (bestandItem) {
      return {
        LangeVertragsnummer: bestandItem.LangeVertragsnummer,
        Name: bestandItem.Name,
        Vorname: bestandItem.Vorname,
        PLZ: bestandItem.PLZ,
        Ort: bestandItem.Ort,
        Produkt: bestandItem.Produkt,
        Status: this.$helpers.statusFix( bestandItem.Status, bestandItem.Ende),
        Vertragsnummer: bestandItem.Vertragsnummer,
        Mahnstatus: bestandItem.Mahnstatus,
        Beginn: this.convertDateToCellObject(bestandItem.Beginn),
        Ende: bestandItem.Ende === "00.01.1900" ? "" : this.convertDateToCellObject(bestandItem.Ende),
        Selbstbehalt: isNaN(Number.parseFloat(bestandItem.Selbstbehalt)) ? "" : Number.parseFloat(bestandItem.Selbstbehalt),
        Beitrag: isNaN(Number.parseFloat(bestandItem.Beitrag)) ? "" : Number.parseFloat(bestandItem.Beitrag),
        Zahlungsweise: bestandItem.Zahlungsweise,
        VertragsTyp: VERTRAGSTYP_VALUES.find(item => item.value === bestandItem.VertragsTyp).text,
        Schaden: bestandItem.Schaeden > 0 ? bestandItem.Schaeden : "",
        Vermittlernummer: bestandItem.LangeVertragsnummer.match(/-([0-9]{5})-/)[1]
      };
    },
    columnFormatBestandDataForExcel: function () {
      return [
        { wch: 20 }, // LangeVertragsnummer
        { wch: 20 }, // Name
        { wch: 15 }, // Vorname
        { wch: 10 }, // PLZ
        { wch: 20 }, // Ort
        { wch: 60 }, // Produkt
        { wch: 10 }, // Status
        { wch: 15 }, // Vertragsnummer
        { wch: 10 }, // Mahnstatus
        { wch: 10 }, // Beginn
        { wch: 10 }, // Ende
        { wch: 10, z: "#,##0.00" }, // Selbstbehalt
        { wch: 10, z: "#,##0.00" }, // Beitrag
        { wch: 25 }, // Zahlungsweise
        { wch: 15 }, // VertragsTyp
        { wch: 10 }, // Schaden
        { wch: 10 }  // Vermittlernummer
      ];
    },
    formatSchadenDataForExcel: function (schaden) {
      return {
        Vertragsnummer: schaden.damage.Vertragsnummer,
        Schadennummer: schaden.damage.Schadennummer,
        // no conversion for Ereignisdatum, can be weired stuff like format with missing days
        Ereignisdatum: schaden.damage.Ereignisdatum !== "00.01.1900" ?  this.convertDateToCellObject(schaden.damage.Ereignisdatum) : "",
        Meldedatum: this.convertDateToCellObject(schaden.damage.Meldedatum),
        Deckungszusage: schaden.damage.Deckungszusage,
        erledigt: schaden.damage.erledigt,
        Kosten: isNaN(Number.parseFloat(schaden.damage.Kosten)) ? "" : Number.parseFloat(schaden.damage.Kosten),
        Leistungsart: formatLeistungsart(schaden.damage.VertragsTyp),
        LangeVertragsnummer: schaden.contract.LangeVertragsnummer,
        Name: schaden.contract.Name,
        Vorname: schaden.contract.Vorname
      };
    },
    columnFormatSchadenDataForExcel: function () {
      return [
        { wch: 15 }, // Vertragsnummer
        { wch: 15 }, // Schadennummer
        { wch: 12 }, // Ereignisdatum
        { wch: 12 }, // Meldedatum
        { wch: 15 }, // Deckungszusage
        { wch: 8 }, // erledigt
        { wch: 10, z: "#,##0.00" }, // Kosten
        { wch: 10 }, // Leistungsart
        { wch: 20 }, // LangeVertragsnummer
        { wch: 20 }, // Name
        { wch: 15 }  // Vorname
      ];
    },
    formatSchadenZumVertragDataForExcel: function (schaden) {
      return {
        Vertragsnummer: schaden.Vertragsnummer,
        Schadennummer: schaden.Schadennummer,
        // no conversion for Ereignisdatum, can be weired stuff like format with missing days
        Ereignisdatum: schaden.Ereignisdatum !== "00.01.1900" ? this.convertDateToCellObject(schaden.Ereignisdatum) : "",
        Meldedatum: this.convertDateToCellObject(schaden.Meldedatum),
        Deckungszusage: schaden.Deckungszusage,
        erledigt: schaden.erledigt,
        Kosten: isNaN(Number.parseFloat(schaden.Kosten)) ? "" : Number.parseFloat(schaden.Kosten),
        Leistungsart: formatLeistungsart(schaden.VertragsTyp),
      };
    },
    columnFormatSchadenZumVertragDataForExcel: function () {
      return [
        { wch: 15 }, // Vertragsnummer
        { wch: 15 }, // Schadennummer
        { wch: 12 }, // Ereignisdatum
        { wch: 12 }, // Meldedatum
        { wch: 15 }, // Deckungszusage
        { wch: 8 }, // erledigt
        { wch: 10, z: "#,##0.00" }, // Kosten
        { wch: 10 }  // Leistungsart
      ];
    },
    formatAntraegeDataForExcel: function (antrag) {
      return {
        Vorname: antrag.vn.firstname,
        Nachname: antrag.vn.lastname,
        Postleitzahl: antrag.vn.plz,
        Ort: antrag.vn.ort,
        Produkt: antrag.categories ? getUmfangFromCategories(antrag.categories) : antrag.scope,
        Datum: this.convertDateToCellObject(antrag.submitTime),
        Vorgangsnummer: antrag.angebotsnummer,
        Vertragsnummer: ""
      };
    },
    columnFormatAntraegeDataForExcel: function () {
      return [
        { wch: 15 }, // Vorname
        { wch: 20 }, // Nachname
        { wch: 10 }, // Postleitzahl
        { wch: 20 }, // Ort
        { wch: 15 }, // Produkt
        { wch: 10 }, // Datum
        { wch: 15 }, // Vorgangsnummer
        { wch: 15 }  // Vertragsnummer
      ];
    },
    formatAngeboteDataForExcel: function (angebot) {
      return {
        Datum: this.convertDateToCellObject(angebot.erstellt),
        Produkt: angebot.categories && Array.isArray(angebot.categories) ? getUmfangFromCategories(angebot.categories) : angebot.leistungsart,
        Art: angebot.art,
        VN: angebot.vn ? angebot.vn.lastname + " " + angebot.vn.firstname : angebot.name,
        Angebotsnummer: angebot.angebotsnummer
      };
    },
    columnFormatAngeboteDataForExcel: function () {
      return [
        { wch: 10 }, // Datum
        { wch: 15 }, // Produkt
        { wch: 15 }, // Art
        { wch: 30 }, // VN
        { wch: 15 } // Angebotsnummer
      ];
    },
    formatSuperuserAngeboteDataForExcel: function (angebot) {
      let frontEndName = "";
      let RechtsformVN = "";
      let StrasseVN = "";
      let HausnummerVN = "";
      let PLZVN = "";
      let OrtVN = "";
      if (angebot.vn) {
        frontEndName = [angebot.vn.lastname, angebot.vn.firstname].filter(name => !!name).join(', ');
        RechtsformVN = angebot.vn.rechtsform ? angebot.vn.rechtsform : angebot.rechtsform ? angebot.rechtsform : "";
        StrasseVN = angebot.vn.strasse ? angebot.vn.strasse : angebot.strasse ? angebot.strasse : "";
        HausnummerVN = angebot.vn.hausnummer ? angebot.vn.hausnummer : angebot.hausnummer ? angebot.hausnummer : "";
        PLZVN = angebot.vn.plz ? angebot.vn.plz : angebot.plz ? angebot.plz : "";
        OrtVN = angebot.vn.ort ? angebot.vn.ort : angebot.ort ? angebot.ort : "";

      } else if (angebot.personen) {
        const vn = angebot.personen.find(p => p.key === 'vn1');
        if (vn) {
          frontEndName = vn.name; 
          RechtsformVN = vn.rechtsform ? vn.rechtsform : angebot.rechtsform ? angebot.rechtsform : "";
          StrasseVN = vn.strasse ? vn.strasse : angebot.strasse ? angebot.strasse : "";
          HausnummerVN = vn.hausnummer ? vn.hausnummer : angebot.hausnummer ? angebot.hausnummer : "";
          PLZVN = vn.plz ? vn.plz : angebot.plz ? angebot.plz : "";
          OrtVN = vn.ort ? vn.ort : angebot.ort ? angebot.ort : "";
        }
      } else {
        StrasseVN = angebot.strasse ? angebot.strasse : "";
        HausnummerVN = angebot.hausnummer ? angebot.hausnummer : "";
        PLZVN = angebot.plz ? angebot.plz : "";
        OrtVN = angebot.ort ? angebot.ort : "";
        RechtsformVN = angebot.rechtsform;
      }
      if (frontEndName === "") {
        frontEndName = angebot.name;
        RechtsformVN = angebot.rechtsform;
      }
      const produkt = angebot.vertrag && angebot.vertrag.produktcode ? PRODUKTE_VALUES.find(p => p.code === angebot.vertrag.produktcode)
        : undefined;
      const frontendProdukt = produkt ? produkt.text
        : angebot.leistungsart ? angebot.leistungsart: this.$store.getters.productLineText(angebot.productLine, angebot.selectedTarif);

      const frontendVersicherungsumfang = Array.isArray(angebot.categories) ? this.getUmfangFromCategories(angebot.categories)
        : Array.isArray(angebot.deckungen) ? this.getUmfangFromDeckungen(angebot.deckungen) : "";
      // prepend string length for sort order to sort by length first; works because length is < 10 in all cases
     
      return {
        VMNR: angebot.selectedIdentity && angebot.selectedIdentity.vmnr ? angebot.selectedIdentity.vmnr : 
        (angebot.user && angebot.user.vmnr) ? angebot.user.vmnr : angebot.vmnr,
        "SB-Nr": angebot.user ? angebot.user.username : angebot.sbnr,
        Datum: this.convertDateToCellObject(angebot.erstellt),
        Angebotsnummer: angebot.angebotsnummer,
        VN: frontEndName,
        Rechtsform: RechtsformVN ? RechtsformVN : angebot.rechtsform ? angebot.rechtsform : "",
        PRODUKT: frontendProdukt,
        UMFANG: frontendVersicherungsumfang,
        Strasse: StrasseVN,
        Hausnummer: HausnummerVN,
        PLZ: PLZVN,
        Ort: OrtVN,
        Art: angebot.art

      };
    },
    columnFormatSuperuserAngeboteDataForExcel: function () {
      return [
        { wch: 10 }, // VMNR
        { wch: 10 }, // SB-Nr
        { wch: 10 }, // Datum
        { wch: 15 }, // Angebotsnummer
        { wch: 20 }, // NAME
        { wch: 15 }, // rechtsform
        { wch: 15 }, // PRODUKTP
        { wch: 15 }, // Umfang
        { wch: 15 }, // Strasse
        { wch: 5 }, // Hausnummer
        { wch: 15 }, // PLZ
        { wch: 15 }, // Ort
        { wch: 15 }  // Art        
      ];
    },
    convertDateToCellObject(dateString) {
      const lextractFromDateString = extractFromDateString;
      const dateParts = lextractFromDateString(dateString);
      const returnIso = true;
      if (!dateParts) {
        return "";
      }
      //return Math.random() < 0.5 ? dateParts.year + "-" + dateParts.month : dateParts.year + "-" + dateParts.month  + "-" + dateParts.day
      if(!returnIso){

        // We want exactly the numbers of dateParts to appear in Excel. To achieve this, we have to provide the time as
        // local time. Since Excel handles daylight saving differently than js "new Date", we start with UTC date and
        // do the timezone adjustment manually
        const currentDaylightSavingLocalDate = Date.UTC(
          dateParts.year,
          dateParts.month - 1,
          dateParts.day,
          dateParts.hour || 0,
          Number(dateParts.minute || 0) + timeZoneOffset,
          dateParts.second || 0
          );
        return new {
            t: 'd',
            v: currentDaylightSavingLocalDate
        };
      } else {
        return `${dateParts.year}${/[0-9][0-9]/.test(dateParts.month) ? '-' + dateParts.month : '' }${ /[0-9][0-9]/.test( dateParts.day ) ? '-' + dateParts.day : ''}`;
      }
    }
  }
};
